import { Pipe, PipeTransform } from '@angular/core';
import type { Dayjs } from 'dayjs';

import { DateService } from '../services/date.service';

@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
  constructor(private dateService: DateService) {}

  transform(
    date: string | number | Date = this.dateService.getDate(),
    formatString = 'MM/DD/YYYY hh:mm A'
  ): string {
    return this.dateService.format(
      this.dateService.parse(date).toString(),
      formatString
    );
  }
}
